import { render, staticRenderFns } from "./initVuex.vue?vue&type=template&id=fdf8ea2c&scoped=true&"
import script from "./initVuex.vue?vue&type=script&lang=js&"
export * from "./initVuex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf8ea2c",
  null
  
)

export default component.exports